module.exports = __webpack_public_path__ + "img/img_35@2x.a59b8f3c.png";